import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '@/views/AITools/store/index'
// enum
import { AIToolNameEnum, AIToolSourceEnum, AIGenerateStatusEnum } from '@/constants/AI-tool'
// utils
import { toast } from '@/utils/util'

@Component({
  props: {
    // 生成状态 ( Pending: 等待生成状态; Generating: 正在生成状态; Finish: 生成完成; )
    status: {
      type: String,
      default: AIGenerateStatusEnum.PENDING
    },
    // 最大长度
    maxLength: {
      type: Number
    },
    // placeholder
    placeholder: {
      type: String,
      default: ''
    },
    // 绑定的文本
    text: {
      type: String
    }
  },
  watch: {
    'text': {
      handler(state) {
        this.textareaModelValue = state
      }
    }
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class AIToolTextarea extends Vue {

  mounted() {

  }

  /****************************** 文本输入 ******************************/

  textareaModelValue = ''

  get wordNum() {
    return this.textareaModelValue.trim().length
  }

  /** textarea 的 input 事件 */
  onInput() {
    if (this.wordNum === this.$props.maxLength) {
      toast(`最多输入${ this.$props.maxLength }字，超出部分自动截断`, 'top', 4000)
    }
    this.$emit('update:text', this.textareaModelValue)
  }

  onPasteText() {
    if (this.wordNum === this.$props.maxLength) {
      toast(`最多输入${ this.$props.maxLength }字，超出部分自动截断`, 'top', 4000)
    }
  }

  /** 点击粘贴 */
  handlePasteText() {
    toast('请点击输入框，长按粘贴内容')
  }

  handleDeleteText() {
    this.textareaModelValue = ''
    this.$emit('update:text', this.textareaModelValue)
  }

}
